export const phone = {
	className: 'icon-phone',
	viewBox: '0 0 195.85078 195.85366',
	paths: ['m 141.99698,62.266439 c -12.703,-12.704 -23.762,-20.538 -1.252,-48.532 22.502,-28 37.5,-6.506 49.809,5.804 14.209,14.202 0.75,67.136 -51.564,119.459001 -52.315999,52.311 -105.249999,65.762 -119.444999,51.565 -12.3089999,-12.311 -33.814,-27.311 -5.813,-49.823 28,-22.502 35.83,-11.438 48.533,1.262 8.871,8.871 31.314,-9.654 50.696999,-29.039 19.382,-19.383001 37.904,-41.825001 29.035,-50.696001 z']
}
